import React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from '@/lib/utils';
import './primitives.css';

/**
 * Accessible underline tabs (Radix: role=tablist/tab/tabpanel, arrow keys,
 * Home/End, roving tabindex, aria-controls wiring).
 *
 *   <Tabs value={tab} onValueChange={setTab}>
 *     <TabList label="Breach monitor sections">
 *       <Tab value="domains" icon={Globe} count={domains.length}>Domains</Tab>
 *       <Tab value="emails">Emails</Tab>
 *     </TabList>
 *     <TabPanel value="domains">...</TabPanel>
 *     <TabPanel value="emails">...</TabPanel>
 *   </Tabs>
 *
 * Panels unmount when inactive (Radix default); pass forceMount to a
 * TabPanel to keep its state.
 */
export function Tabs({ className, ...props }) {
  return <TabsPrimitive.Root className={className} {...props} />;
}

export function TabList({ label, className, children, ...props }) {
  return (
    <TabsPrimitive.List aria-label={label} className={cn('is-tabs-list', className)} {...props}>
      {children}
    </TabsPrimitive.List>
  );
}

export function Tab({ value, icon: Icon, count, className, children, ...props }) {
  return (
    <TabsPrimitive.Trigger value={value} className={cn('is-tab', className)} {...props}>
      {Icon && <Icon aria-hidden="true" />}
      <span>{children}</span>
      {count != null && (
        <span className="is-tab-count">
          {count}
          <span className="sr-only"> items</span>
        </span>
      )}
    </TabsPrimitive.Trigger>
  );
}

export function TabPanel({ value, className, ...props }) {
  return <TabsPrimitive.Content value={value} className={cn('is-tab-panel', className)} {...props} />;
}

export default Tabs;
